var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"validation"},[_c('DatePicker',{staticClass:"mb-3",attrs:{"label":_vm.label,"minDate":_vm.allowedDate,"validateName":"expiry","input-value":_vm.compliance.documentValidToDate,"showValidationErrors":_vm.showValidationErrors,"required":"","isDark":""},on:{"onChange":_vm.setExpiryDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }